<fieldset
    class="m-input-group"
    :class="{
        'm--is-disabled': isDisabled,
        'm--has-error': hasError,
        'm--is-valid': isValid,
        'm--has-validation-message': hasValidationMessage,
        'm--is-validation-message-position-bottom': isValidationMessagePositionBottom
    }"
    @focusin="emitFocusin"
    @focusout="emitFocusout"
>
    <legend
        v-if="hasLabel"
        :id="labelId"
        class="m-input-group__label"
    >
        {{ label }}
        <span
            v-if="$slots.icon"
            class="m-input-group__icon"
        >
            <slot name="icon" />
        </span>&nbsp;<sup v-if="requiredMarker"
             class="m-input-group__required-marker">*</sup>
    </legend>
    <div class="m-input-group__body">
        <m-validation-message
            :id="validationMessageId"
            class="m-input-group__message"
            :disabled="isDisabled"
            :waiting="isWaiting"
            :error="hasError"
            :error-message="errorMessage"
            :valid="isValid"
            :valid-message="validMessage"
            :helper-message="helperMessage"
        />
        <div
            v-if="$slots.default"
            class="m-input-group__content"
            :aria-labelledby="labelId"
            :aria-describedby="validationMessageId"
        >
            <slot />
        </div>
    </div>
</fieldset>
